import { EventEmitter, Injectable } from "@angular/core";

@Injectable({
    providedIn: "root"
})
export class ModifyCountEmmiter{
    public ejecutaAccionMenus: EventEmitter<any> = new EventEmitter();
}